"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var PlayerBonusAdd = /** @class */ (function (_super) {
    __extends(PlayerBonusAdd, _super);
    function PlayerBonusAdd(props) {
        return _super.call(this, props) || this;
    }
    PlayerBonusAdd.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            bonus_tpl_id: 0,
            bonus_tpl_title: "",
            bonus_amt_amount: 0,
            bonus_tpl_avail: []
        });
        this.SID_BTA = this.props.listBonusTemplatesAvail.Subscribe("*", function (id, data) {
            _this.setState({ bonus_tpl_avail: data.data });
        });
        this.doReSetRules();
        this.props.listBonusTemplatesAvail.LoadData(this.props.rootRecord.key, true, true);
    };
    PlayerBonusAdd.prototype.componentWillUnmount = function () {
        this.props.listBonusTemplatesAvail.UnSubscribe(this.SID_BTA);
    };
    PlayerBonusAdd.prototype.doReSetRules = function () {
        this.setState({
            bonus_tpl_rules: { isError: false },
            bonus_amt_rules: { isError: false }
        });
    };
    PlayerBonusAdd.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.bonus_tpl_id <= 0) || (this.state.bonus_tpl_title.length === 0)) {
            this.setState({ bonus_tpl_rules: { isError: true, errorMessage: "Поле [шаблон бонуса] не заполнено!" } });
            return false;
        }
        if (!this.state.bonus_tpl_need_amount) {
            if ((this.state.bonus_amt_amount < 0) || (this.state.bonus_amt_amount > 9999999)) {
                this.setState({
                    bonus_amt_rules: {
                        isError: true,
                        errorMessage: "Поле [сумма бонуса] имеет недопустимое значение"
                    }
                });
                return false;
            }
        }
        return true;
    };
    PlayerBonusAdd.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_player_id: this.props.rootRecord.key,
                bonus_template_id: this.state.bonus_tpl_id,
                amount: this.state.bonus_amt_amount
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бонус добавлен!");
            });
        }
    };
    PlayerBonusAdd.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerBonusAdd.prototype.getFormTitle = function () {
        return "Добавить бонус";
    };
    PlayerBonusAdd.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 350 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Выберите шаблон:", placeholder: "Выберите шаблон" }, value: { key: this.state.bonus_tpl_id, value: this.state.bonus_tpl_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_tpl_id: newVal.key,
                        bonus_tpl_title: newVal.value,
                        bonus_tpl_rules: { isError: false }
                    }, function () {
                        var _checked = false;
                        for (var i = 0; i < _this.state.bonus_tpl_avail.length; i++) {
                            if (_this.state.bonus_tpl_avail[i].key == _this.state.bonus_tpl_id) {
                                _checked = _this.state.bonus_tpl_avail[i].checked;
                                break;
                            }
                        }
                        _this.setState({ bonus_tpl_need_amount: _checked });
                    });
                }, items: this.state.bonus_tpl_avail, required: true, rules: this.state.bonus_tpl_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Сумма бонуса:",
                    placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443 \u0431\u043E\u043D\u0443\u0441\u0430, " + this.props.rootRecord.app_currency_title
                }, values: { min: 1, max: 999999999, value: this.state.bonus_amt_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_amt_amount: newVal,
                        bonus_amt_rules: { isError: false }
                    });
                }, required: true, rules: this.state.bonus_amt_rules, disabled: !this.state.bonus_tpl_need_amount }),
            React.createElement(CardRowButtonSet_1.default, { editMode: false, title: { btnEdit: "", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: function () { } })));
    };
    return PlayerBonusAdd;
}(React.Component));
exports.default = PlayerBonusAdd;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/bonuses/PlayerBonusAdd.tsx
// module id = 1931
// module chunks = 0